import { SupplierBaseProduct } from "../../types/supplierBaseProduct";

export function findBaseProduct(id:string, baseProducts: SupplierBaseProduct[]) : SupplierBaseProduct | undefined  {
    return baseProducts.find((bp) => bp.id === id);
}